/** This module correctly load Turtle and SPARQL highlighting languages. */
export const name = "stichting-crow/rdf-highlight";

async function loadLang({ langURL, propName, lang }) {
  /** @type {Worker} */
  const worker = await new Promise(resolve => {
    require(["core/worker"], ({ worker }) => resolve(worker));
  });
  const action = "highlight-load-lang";
  worker.postMessage({ action, langURL, propName, lang });
  return new Promise(resolve => {
    worker.addEventListener("message", function listener({ data }) {
      const { action: responseAction, lang: responseLang } = data;
      if (responseAction === action && responseLang === lang) {
        worker.removeEventListener("message", listener);
        resolve();
      }
    });
  });
}

export async function run() {
  // Nothing to highlight
  const rdfLanguages = [
    {
      langURL:
        "https://cdn.jsdelivr.net/gh/redmer/highlightjs-turtle@v2.1.0/src/languages/turtle.min.js",
      propName: "hljsDefineTurtle",
      lang: "turtle",
    },
    {
      langURL:
        "https://cdn.jsdelivr.net/gh/redmer/highlightjs-sparql@v2.1.0/src/languages/sparql.min.js",
      propName: "hljsDefineSparql",
      lang: "sparql",
    },
  ];

  await Promise.all(rdfLanguages.map(value => loadLang(value)));
}
